var map = {
  "./amex.svg": "5974",
  "./diners.svg": "2768",
  "./discover.svg": "5510",
  "./jcb.svg": "8844",
  "./mastercard.svg": "3531",
  "./other.svg": "2795",
  "./visa.svg": "44"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = function() { return Object.keys(map); };
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 9867;
